import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

export function Debug() {
  const [info, setInfo] = useState<any>({})
  const [error, setError] = useState<string>('')

  useEffect(() => {
    checkAuth()
  }, [])

  const checkAuth = async () => {
    try {
      // Check if environment variables are set
      const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
      const hasUrl = !!supabaseUrl
      const hasKey = !!process.env.REACT_APP_SUPABASE_ANON_KEY

      // Get current user
      const { data: { user }, error: userError } = await supabase.auth.getUser()

      if (userError) {
        setError(`Auth error: ${userError.message}`)
      }

      // Try to fetch from profiles
      let profilesError = null
      if (user) {
        const { error } = await supabase
          .from('profiles')
          .select('*')
          .limit(1)
        profilesError = error
      }

      setInfo({
        hasSupabaseUrl: hasUrl,
        supabaseUrl: supabaseUrl ? `${supabaseUrl.substring(0, 30)}...` : 'NOT SET',
        hasAnonKey: hasKey,
        isAuthenticated: !!user,
        userId: user?.id || 'Not logged in',
        userEmail: user?.email || 'Not logged in',
        profilesAccessible: !profilesError,
        profilesError: profilesError?.message || 'None',
        timestamp: new Date().toISOString()
      })
    } catch (err: any) {
      setError(err.message)
    }
  }

  return (
    <div className="p-8 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">Debug Information</h1>

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          {error}
        </div>
      )}

      <div className="bg-white dark:bg-surface-100 rounded-lg shadow p-6">
        <h2 className="text-lg font-semibold mb-4 text-gray-900 dark:text-white">Environment</h2>
        <div className="space-y-2">
          {Object.entries(info).map(([key, value]) => (
            <div key={key} className="flex justify-between py-2 border-b border-gray-200 dark:border-gray-700">
              <span className="font-medium text-gray-700 dark:text-gray-300">{key}:</span>
              <span className="text-gray-900 dark:text-white">{String(value)}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-6 bg-yellow-100 border-l-4 border-yellow-500 p-4">
        <p className="text-sm">
          If you see 401 errors, check that you are signed in and that your account has a profile. Don't change database policies to get around it.
        </p>
      </div>
    </div>
  )
}